module.exports = __webpack_public_path__ + "media/images/file-icons/64/004-folder-1-d676cca7d0e5047c7f8f913c5150d7cd.png";